const JOB_DESCIPTION_STORAGE_KEY = 'job-description';

/**
 * Set job description in session storage for use in message flow/forms
 */
export const setJobDescription = (description: string) => {
  if (typeof sessionStorage === 'undefined') {
    return;
  }

  sessionStorage.setItem(JOB_DESCIPTION_STORAGE_KEY, description);
};

/**
 * Retrieves job description from session storage
 */
export const getJobDescription = () => {
  if (typeof sessionStorage === 'undefined') {
    return '';
  }

  return sessionStorage.getItem(JOB_DESCIPTION_STORAGE_KEY) ?? '';
};
